export const HeaderData = [
    {
        title: 'Hombre',
        path: '/',
        cName:'nav-text'
    },
    {
        title: 'Mujer',
        path: '/',
        cName:'nav-text'
    },
    {
        title: 'Junior',
        path: '/',
        cName:'nav-text'
    },
    {
        title: 'Niños',
        path: '/',
        cName:'nav-text'
    },
    {
        title: 'Accesorios',
        path: '/',
        cName:'nav-text'
    },
    {
        title: 'Ofertas',
        path: '/',
        cName:'nav-text'
    },

]
